import { IPostClaimCta, IPostClaimScenarioConfig } from '../types/ui';

const DEFAULT_COUNTDOWN_SECONDS = 10;
const ALLOWED_PROTOCOL = 'https://';

export const parsePostClaimScenarios = (raw: string | undefined): Map<string, IPostClaimCta> => {
  const config = new Map<string, IPostClaimCta>();

  if (!raw) {
    return config;
  }

  let parsed: unknown;

  try {
    parsed = JSON.parse(raw);
  } catch {
    console.warn('[post-claim-cta] REACT_APP_POST_CLAIM_SCENARIOS is not valid JSON — CTA disabled');

    return config;
  }

  if (!Array.isArray(parsed)) {
    console.warn('[post-claim-cta] REACT_APP_POST_CLAIM_SCENARIOS is not an array — CTA disabled');

    return config;
  }

  parsed.forEach((entry) => {
    const { scenario, label, url, countdownSeconds } = (entry || {}) as Partial<IPostClaimScenarioConfig>;

    // Runs at module load from an env string, so a malformed url must be dropped, not thrown on.
    const hasSafeUrl = typeof url === 'string' && url.startsWith(ALLOWED_PROTOCOL);

    if (!scenario || !label || !hasSafeUrl || config.has(scenario)) {
      return;
    }

    const seconds = Number(countdownSeconds);

    config.set(scenario, {
      label,
      url,
      countdownSeconds: Number.isFinite(seconds) && seconds > 0 ? seconds : DEFAULT_COUNTDOWN_SECONDS,
    });
  });

  return config;
};

export const resolvePostClaimCta = (
  scenarios: string[],
  config: Map<string, IPostClaimCta>,
): IPostClaimCta | undefined => {
  const match = scenarios.find((value) => config.has(value));

  return match ? config.get(match) : undefined;
};
